import MVideo from './MVideo.vue';

export { MVideo };
export default MVideo;
